module.exports = __webpack_public_path__ + "assets/img/activity-time-5cda190a.png";